import morphism from 'morphism';

import { productResponse, recognitionRequest, recognitionResponse } from '@hero/schemas';

import { api } from '../api';

import { endpoints } from './endpoints';

export const services = {
  create: formData =>
    api
      .post(endpoints.list(), morphism(recognitionRequest.create, formData))
      .then(res => res.data.data),
  products: code =>
    api
      .get(endpoints.products(code))
      .then(res => morphism(productResponse.searchProductSchema, res.data.data)),
  list: params =>
    api
      .get(endpoints.list(), { params })
      .then(res => morphism(recognitionResponse.list, res.data.data)),
  detail: code =>
    api
      .get(endpoints.detail(code))
      .then(res => morphism(recognitionResponse.recognition, res.data.data)),
  spendingSummary: code =>
    api
      .get(endpoints.spendingSummary(code))
      .then(res => res.data.data)
      .catch(e => {
        e.code = 'ERR_CANCELED';
        throw e;
      }),
  acceptanceRate: code => api.get(endpoints.acceptanceRate(code)).then(res => res.data.data),
  update: (code, params) =>
    api
      .put(endpoints.detail(code), morphism(recognitionRequest.update, params))
      .then(res => res.data.data),
  delete: code => api.delete(endpoints.detail(code)).then(res => res.data.data),
  start: code => api.put(endpoints.start(code)).then(res => res.data.data),
  orders: params => api.get(endpoints.orders(), { params }).then(res => res.data.data),
  orderDetail: code => api.get(endpoints.order(code)).then(res => res.data.data),
  orderUpdate: (code, params) => api.put(endpoints.order(code), params).then(res => res.data.data),
  duplicate: (code, body) =>
    api
      .post(endpoints.detailDuplicate(code), morphism(recognitionRequest.duplicate, body))
      .then(res => res.data.data),
  popularGifts: params => api.get(endpoints.popularGifts, { params }).then(res => res.data.data),
  share: (recognitionCode, params) =>
    api.put(endpoints.share(recognitionCode), params).then(res => res.data.data),
  sendReminder: ({ params, body }) =>
    api.post(endpoints.sendReminder(params), body).then(res => res.data),
  recogRecipientsBulkUpsert: ({ params: { code } = {}, body }) =>
    api.post(endpoints.recogRecipientsBulkUpsert(code), body).then(res => res.data.data),
  recogRecipientsList: (code, params) =>
    api.get(endpoints.recogRecipientsList(code), { params }).then(res => res.data.data),
  recogRecipientsDelete: ({ code, ...params }) => {
    return api({
      method: 'DELETE',
      url: endpoints.recogRecipientsDelete({ code }),
      data: params
    }).then(res => res.data.data);
  },
  recogLiveRecipientsDelete: ({ code, email, ...params }) => {
    return api({
      method: 'DELETE',
      url: endpoints.recogLiveRecipientsDelete({ code, email }),
      data: params
    }).then(res => res.data.data);
  },
  recognitionReachOutSupport: (params, body) =>
    api.post(endpoints.recognitionReachOutSupport(params), body).then(res => res.data.data),
  calculateEstimatedCharge: (params, body) =>
    api
      .post(
        endpoints.calculateEstimatedCharge(params),
        morphism(recognitionRequest.calculateEstimatedCharge, body)
      )
      .then(res => res.data.data),
  submitToApproval: ({ code, approvalType }) =>
    api.put(endpoints.submitToApproval(code), { approvalType }).then(res => res.data.data),
  expireRecognition: code =>
    api.put(endpoints.expireRecognition({ code })).then(res => res.data.data),
  goLiveFlags: code => api.get(endpoints.goLiveFlags(code)).then(res => res.data.data)
};
